module.exports = __webpack_public_path__ + "img/49.ab6f3737.jpg";